import clsx from 'clsx';

export function Container({
  as: Component = 'div',
  className,
  children,
}: {
  as?: any;
  className?: string;
  children?: React.ReactNode;
}) {
  return <Component className={clsx('px-6 lg:px-12', className)}>{children}</Component>;
}